import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function NotchLeft({ idVariant = '', className }: Props) {
  return (
    <IconBase name="notch-left" w={38} className={className}>
      <path d="M0 18H0.715729C6.02006 18 11.1071 15.8929 14.8579 12.1421L21.1421 5.85786C24.8929 2.10713 29.9799 0 35.2843 0H38V38H0V18Z" fill="currentColor"/>
    </IconBase>
  )
}

export default NotchLeft
